/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';

class VerifyingDetail extends React.Component {
  render() {
    return <div className='dms-body'>
      {this.props.children}
    </div>
  }
};
export default VerifyingDetail;


// WEBPACK FOOTER //
// ./src/routes/financialMgm/verifyingDetail.js